module.exports = __webpack_public_path__ + "static/media/Illust@3x.dd9a5bbf.png";